module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_SwanCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_SwanCity.png
// module id = 2091
// module chunks = 4